var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8576 4.3728C12.4692 3.72546 11.531 3.72546 11.1426 4.3728L2.67497 18.4855C2.27506 19.152 2.75517 20 3.53246 20H20.4677C21.245 20 21.7251 19.152 21.3252 18.4855L12.8576 4.3728ZM9.4276 3.34381C10.5928 1.40179 13.4074 1.4018 14.5726 3.34381L23.0402 17.4565C24.2399 19.4561 22.7996 22 20.4677 22H3.53246C1.20058 22 -0.239756 19.4561 0.959987 17.4565L9.4276 3.34381ZM12.0001 8C12.5524 8 13.0001 8.44771 13.0001 9V13C13.0001 13.5523 12.5524 14 12.0001 14C11.4478 14 11.0001 13.5523 11.0001 13V9C11.0001 8.44771 11.4478 8 12.0001 8ZM12.0001 15C12.5524 15 13.0001 15.4477 13.0001 16V17C13.0001 17.5523 12.5524 18 12.0001 18C11.4478 18 11.0001 17.5523 11.0001 17V16C11.0001 15.4477 11.4478 15 12.0001 15Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.2639fa6d52fd255fad875b6d492b8424.svg";
export { ForwardRef as ReactComponent };